export default {

  aaBattery: {
    name: 'AA battery'
  },

  aaaBattery: {
    name: 'AAA battery'
  },

  dBattery: {
    name: 'D battery'
  },

  decoderPowerBrick: {
    name: 'Power brick'
  },

  voltageMeter: {
    name: 'Voltage meter'
  }

}
